import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'

export default function BulkTemplate({ bulk }: { bulk: any }) {
	const tooltipCopyBulkCID = useRef<TooltipRefProps>(null)
	const tooltipCopySignature = useRef<TooltipRefProps>(null)

	return (
		<>
			{bulk.properties.bulkCID && (
				<div
					id="bulkCID"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(bulk.properties.bulkCID)
						tooltipCopyBulkCID.current?.open({
							anchorSelect: '#title',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyBulkCID.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyBulkCID} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Bulk CID:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{bulk.properties.bulkCID}
					</TypographyParagraph>
				</div>
			)}
			<div
				id="signature"
				className="flex flex-row p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(bulk.signature)
					tooltipCopySignature.current?.open({
						anchorSelect: '#signature',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopySignature.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopySignature} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Signature:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{bulk.signature}
				</TypographyParagraph>
			</div>
		</>
	)
}
